import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, type BoxProps, Stack } from "@mui/material";
import { imageSource } from "@app/constants";

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const LogoSidebar = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const logoSide = (
      <Box
        gap={1}
        ref={ref}
        alignItems={"center"}
        justifyContent={"center"}
        component="div"
        sx={{
          ...sx,
        }}
        {...other}
      >
        <Stack sx={{ display: { xs: "none", sm: "block" } }}>
          <img
            src={imageSource.logo}
            alt="logo"
            height={40}
            width={270}
            loading="lazy"
          />
        </Stack>
      </Box>
    );

    if (disabledLink) {
      return logoSide;
    }

    return (
      <Link component={RouterLink} to="/" sx={{ display: "contents" }}>
        {logoSide}
      </Link>
    );
  }
);

export { LogoSidebar };
